import { z } from 'zod';

export const schemaConsorsDateYYYYMMDD = z
    .string()
    .regex(/^(19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/, 'Invalid characters');
export type SchemaConsorsDateYYYYMMDD = z.infer<typeof schemaConsorsDateYYYYMMDD>;
